import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {RouterModule} from '@angular/router';

declare var $: any;
declare var App: any;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'merchant-desktop';

  constructor(private translate: TranslateService) {
    let lang = window.localStorage.getItem('lang');

    if (lang == null) {
      lang = 'ar';
      window.localStorage.setItem('lang', 'ar');
    }

    if (lang == 'en') {
      this.translate.setDefaultLang('en');
    } else {
      this.translate.setDefaultLang('ar');
    }
  }

  ngOnInit() {
  }

}
